import React from "react";

type ErrorBoundaryProps = {
    children: React.ReactNode;
};

type ErrorBoundaryState = {
    hasError: boolean;
    error: Error | null;
};

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {hasError: false, error: null};
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return {hasError: true, error};
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error("Error caught by boundary:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{padding: "20px", color: "red"}}>
                    <h1>Something went wrong.</h1>
                    {process.env.NODE_ENV === "production" ? (
                        <p>Please reload the page or try again later.</p>
                    ) : (
                        <>
                            <pre>{this.state.error?.toString()}</pre>
                            <pre>{this.state.error?.stack}</pre>
                        </>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}
